import React, { useState } from 'react';
import { createStyles, withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import { makeStyles } from '@material-ui/core/styles';
import { patterns, REASON_MAX_LENGTH, REASON_ROWS, getReasonHelperText } from './CreatePayment';

const styles = theme => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});

const DialogTitle = withStyles(styles)(props => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h5" style={{ fontSize: '16px' }}>{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

const DialogContent = withStyles(theme => ({
    root: {
        padding: theme.spacing(2),
        paddingBottom: theme.spacing(4),
        overflowY: 'auto',
    },
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
    root: {
        margin: 0,
        padding: theme.spacing(2, 3, 3),
        justifyContent: 'center',
    },
}))(MuiDialogActions);

const useStyles = makeStyles({
    saveBtn: {
        fontSize: '13px',
        textTransform: 'none',
    },
    label: {
        margin: 0,
        marginTop: '15px',
        paddingLeft: '16px',
        marginBottom: '20px',
        fontSize: '15px'
    }
});

export default function AddAdjustmentFeeDialog(props) {
    const classes = useStyles();
    const [amount, setAmount] = useState('');
    const [reason, setReason] = useState('');
    const [amountError, setAmountError] = useState(false);
    const [isValidReason, setIsValidReason] = useState(true);

    const handleClose = () => {
        props.closeDialog();
    };

    const validateAmount = (value) => {
        if (!value || value.length === 0) return false;
        return !!value.match(patterns.amount);
    };

    const changeAmount = (e) => {
        const value = e.target.value.trim();
        setAmount(value);
        setAmountError(!validateAmount(value));
    };

    const changeReason = (e) => {
        const value = e.target.value.slice(0, REASON_MAX_LENGTH);
        setReason(value);
        setIsValidReason(value.trim().length > 0);
    };

    const isFormValid = () => {
        return validateAmount(amount) && reason.trim().length > 0;
    };

    const confirmAddFee = () => {
        props.confirmAddFee({
            adjustmentFee: parseFloat(amount).toFixed(2),
            reason: reason.trim()
        });
    };

    return (
        <Dialog
            onClose={handleClose}
            aria-labelledby="adjustment-fee-dialog"
            open={props.isOpen}
            maxWidth={"sm"}
            fullWidth={true}
            scroll="paper"
            PaperProps={{
                style: {
                    maxHeight: '90vh',
                },
            }}
        >
            <DialogTitle id="adjustment-fee-dialog" onClose={handleClose}>
                Add Adjustment Fee
            </DialogTitle>
            <DialogContent dividers>
                <div className="refund-dialouge">
                    <p className="month-label">
                        Transaction ID: <span className="month-no">{props.transactionData.transactionId}</span>
                    </p>
                    <p className="msg">Add an operational adjustment fee to this approved transaction.</p>
                </div>

                <div className={classes.label} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ width: '40%' }}>Adjustment Fee Amount: *</div>
                    <TextField
                        variant="outlined"
                        placeholder="Enter Amount"
                        value={amount}
                        style={{ width: '55%' }}
                        onChange={changeAmount}
                        required={true}
                        error={amountError}
                        helperText={amountError ? 'Enter a valid Adjustment Fee Amount' : ''}
                        InputProps={{
                            startAdornment: <InputAdornment position="start">$</InputAdornment>,
                            style: { fontSize: '14px' }
                        }}
                    />
                </div>

                <div className={classes.label} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <div style={{ width: '40%', marginTop: '10px' }}>Reason for Adjustment: *</div>
                    <TextField
                        variant="outlined"
                        multiline
                        rows={REASON_ROWS}
                        placeholder="Enter Reason"
                        value={reason}
                        style={{ width: '55%' }}
                        required={true}
                        error={!isValidReason}
                        helperText={getReasonHelperText(reason)}
                        onBlur={() => setIsValidReason(reason.trim().length > 0)}
                        onChange={changeReason}
                        inputProps={{ maxLength: REASON_MAX_LENGTH, style: { fontSize: '14px' } }}
                    />
                </div>
            </DialogContent>

            <DialogActions>
                <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    className={classes.saveBtn}
                    onClick={confirmAddFee}
                    disabled={!isFormValid() || amountError}
                >
                    Confirm
                </Button>
            </DialogActions>
        </Dialog>
    );
}
